import React from "react";

const Chat = (props) => {
  return (
    <div>
      {/* <div id="chat-box"> */}
        {/* <div id="chat-container"> */}
          {props.children}
        </div>
      // </div>
    // </div>
  );
};

export default Chat;
